import get from 'lodash/get';
import omit from 'lodash/omit';
import { ElementType } from 'react';
import { Form } from 'react-bootstrap';
import { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';
import { ApiError } from '../../../api';
import type { ShowFieldErrors } from '../../../utils/forms';
import { FormFeedback } from '../FormFeedback';
import { FormFieldVisibility, FormLabel } from '../FormLabel';

interface FormTextareaFieldProps {
  name: string;
  label: string;
  serverErrors?: ApiError;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  as?: ElementType<any>;
  showServerFieldErrors?: ShowFieldErrors;
  setShowServerFieldErrors?: (showServerFieldErrors: ShowFieldErrors) => void;
  errors: FieldErrors<FieldValues>;
  register: UseFormRegister<FieldValues>;
  extraFieldErrorsToHideOnChange?: string[];
  required?: boolean;
  srOnlyLabel?: boolean;
  visibility?: FormFieldVisibility;
  placeholder?: string;
}

export const FormTextareaField = ({
  name,
  label,
  serverErrors,
  showServerFieldErrors,
  setShowServerFieldErrors,
  errors,
  register,
  extraFieldErrorsToHideOnChange = [],
  required = false,
  srOnlyLabel = false,
  visibility,
  placeholder = '',
  ...rest
}: FormTextareaFieldProps & Parameters<typeof Form.Control>[0]) => (
  <Form.Group className="mb-3" controlId={name}>
    <FormLabel required={required} visibility={visibility} srOnlyLabel={srOnlyLabel}>
      {label}
    </FormLabel>
    <Form.Control
      type="text"
      placeholder={placeholder}
      as="textarea"
      {...register(name, {
        onChange: () =>
          setShowServerFieldErrors?.({
            ...omit(showServerFieldErrors, [name, ...extraFieldErrorsToHideOnChange]),
          }),
      })}
      {...rest}
      isInvalid={!!errors[name] || !!get(showServerFieldErrors, name)}
    />
    <FormFeedback
      clientError={errors[name]}
      serverErrors={get(showServerFieldErrors, name) ? get(serverErrors?.body, name) : null}
    />
  </Form.Group>
);
